import { render, staticRenderFns } from "./CancelDeleteAppointmentModal.vue?vue&type=template&id=2dc6aa38&scoped=true&"
import script from "./CancelDeleteAppointmentModal.vue?vue&type=script&lang=ts&"
export * from "./CancelDeleteAppointmentModal.vue?vue&type=script&lang=ts&"
import style0 from "./CancelDeleteAppointmentModal.vue?vue&type=style&index=0&id=2dc6aa38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc6aa38",
  null
  
)

export default component.exports